import { render, staticRenderFns } from "./DirectoryBase.vue?vue&type=template&id=c0fdd5c6"
import script from "./DirectoryBase.vue?vue&type=script&lang=js"
export * from "./DirectoryBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports